import {usePanel} from '../app/PanelProvider.js';

/**
 * Área de anúncio das ações. Fica fora das páginas porque ações de páginas
 * diferentes precisam anunciar resultado no mesmo lugar.
 *
 * Erro entra como `alert`, e não como `status`, para o leitor de tela
 * interromper: o usuário precisa saber na hora que a ação não aconteceu.
 */
export const ToastRegion = () => {
  const {toast} = usePanel();

  if (!toast) {
    return null;
  }

  return (
    <div
      className="dm-toast"
      role={toast.tone === 'error' ? 'alert' : 'status'}
      aria-live={toast.tone === 'error' ? 'assertive' : 'polite'}
    >
      {toast.message}
    </div>
  );
};
